import { CloseCircleIcon } from '../../../icons'
import './simple-text-input.scss'

const SimpleTextInput = ({ icon, value, placeholder, hasError, disabled, onChange, onClear, onBlur, className = '' }) => {
  return (
    <div className={`simple-text-input-wrapper ${className} ${hasError ? 'has-error' : ''} ${disabled ? 'disabled' : ''}`}>
      {icon && <div className="input-item-icon">{icon}</div>}
      <input type="text" className="input-item" value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} onBlur={onBlur} />
      {onClear && value?.length > 0 && (
        <div className="input-item-icon clear-action" onClick={onClear}>
          <CloseCircleIcon />
        </div>
      )}
    </div>
  )
}

export default SimpleTextInput
